import React from "react";
import { TextField } from '@mui/material';
import { styled } from "@mui/material";

import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';



const useStyles = styled((theme) => ({
    root: {
        display: "inline",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
    },
    textField: {
        width: "30%",
        marginBottom: theme.spacing(2),
    },
}));

export default function PageOne({ handleNext }) {
    const classes = useStyles();
    const handleSubmit = (event) => {
        event.preventDefault();
        handleNext();
    };

    return (
        <div className="formContainer">
            <form className={classes.root} onSubmit={handleSubmit}>
                <div className="partOne">
                    <FormControl>
                        <Grid container>
                            <Grid item md={4} xs={12}>
                                <div className="label">Name:</div>
                                <TextField
                                    required
                                    id="name"
                                    label=""
                                    defaultValue=""
                                />
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <div className="label">Info:</div>
                                <TextField
                                    required
                                    id="info1"
                                    label=""
                                    defaultValue=""
                                />
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <div className="label">Info:</div>
                                <TextField
                                    required
                                    id="info2"
                                    label=""
                                    defaultValue=""
                                />
                            </Grid>
                            <Grid item md={12} xs={12}>
                                <div className="label">Info:</div>
                                <Box
                                    component="form"
                                    sx={{
                                        '& .MuiTextField-root': { m: 1, width: '200px' },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >

                                    <div className="multiLine">
                                        <TextField
                                            id="info3"
                                            label=""
                                            multiline

                                        />
                                    </div>
                                </Box>
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <div className="label">Floors:</div>
                                <TextField
                                    required
                                    id="info4"
                                    label=""
                                    defaultValue=""
                                />
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <div className="label">Users:</div>
                                <TextField
                                    required
                                    id="info5"
                                    label=""
                                    defaultValue=""
                                />
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <div className="label">Info:</div>
                                <TextField
                                    required
                                    id="info6"
                                    label=""
                                    defaultValue=""
                                />
                            </Grid>
                            <Grid item md={12} xs={12}>
                                <div className="label">Info:</div>
                                <TextField
                                    id="info7"
                                    label=""
                                />
                            </Grid>
                        </Grid>
                    </FormControl>
                </div>
            </form>
        </div>
    );
}